module.exports = "/assets/d109337510a87b54b741c2697ab9d823.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AY.png
// module id = 1212
// module chunks = 0